// extracted by mini-css-extract-plugin
export var chip = "_fk-0";
export var filterDropdown = "_fk-5";
export var filterItem = "_fk-6";
export var icon = "_fk-1";
export var removeButton = "_fk-3";
export var removeIcon = "_fk-4";
export var separator = "_fk-2";